/**
 * 点像素聚合图层
 * Created by 1 on 2016/12/14.
 */
'use strict';
/**
 * 点状图层分布基类
 * @module PointClusterLayer
 */
define([
    './PointLayer',
    '../utils/CommonUtil',
    '../utils/LoggerUtil',
    '../g2'
],function(
    PointLayer,
    CommonUtil,
    LoggerUtil,
    g2
){
    /**
     * 构造方法
     * @constructor
     * @classdesc 像素聚合点图层
     * @augments G.lys.PointLayer
     * @alias G.lys.PointClusterLayer
     * @param {Object} options - 必填，构造参数；
     * @param {G.Map/g2.carto.Map} options.map -必填，地图对象
     * @param {String} options.layerId - 可选，图层id，默认为随机字符串
     * @param {String} options.idKey - 必填，数据记录中作为唯一标识的字段名
     * @param {String} options.attributeField - 可选，数据记录中属性信息挂接的属性名，默认为空
     * @param {String} options.geometryField - 可选，数据记录中空间属性名，默认为空，如果有值，则几何使用数据记录中对应的坐标信息；
     * @param {String} options.xField - 可选，数据记录中x坐标字段名，默认为LONGITUDE
     * @param {String} options.yField - 可选，数据记录中y坐标字段名，默认为LATITUDE
     * @param {Object} options.symbolConfig - 必填，符号配置
     * @param {String} options.defaultSymbolKey - 可选，符号配置文件中默认符号的key值，默认为default
     * @param {Number} options.spatialReference - 可选，图层坐标系，默认4326
     * @param {Number} options.dataSpatialReference - 可选，叠加数据的坐标系，默认图层坐标系
     * @param {Function} options.symbolUpdateCallback - 可选，地图显示的符号更新时的回调，
     * @param {Object} options.callbackContext - 可选，回调的上下文
     * @returns {Class} - 实例化的对象
     */
    var layer=PointLayer.extend({
        options:{
        },
        initialize:function(options){
            PointLayer.prototype.initialize.call(this,options);
            //聚合符号模板
            this._defaultClusterStyle={
                "textFillColor":{"alpha": 255, "r": 255, "g": 255, "b": 255},
                "fillColor":{"alpha": 200, "r": 0, "g": 0, "b": 255},
                "fillStrokeColor":{"alpha": 100, "r": 0, "g": 0, "b": 255},
                "fillStrokeWidth":10,
                "distance":10,
                "clusterLevel":10
            };
            //聚合符号
            var clusterStyle=this.symbolConfig.cluster||this._defaultClusterStyle;
            //保存聚合的符号
            this._clusterSymbol=jQuery.extend(true,{
                $type:'pixelcluster'
            },clusterStyle);
            this._clusterSymbol.fillStrokeColor=this._getColor(this._clusterSymbol.fillStrokeColor);
            this._clusterSymbol.fillColor=this._getColor(this._clusterSymbol.fillColor);
            this._clusterSymbol.textFillColor=this._getColor(this._clusterSymbol.textFillColor);
            //
            var colors=['textFillColor','fillColor','fillStrokeColor'];
            for(var key in colors){
                var style=clusterStyle[colors[key]];
                if(!style){
                    continue;
                }
                clusterStyle[colors[key]]=this._getColor(style).toArray();
            }
            var lyrOpts={
                id:this.options.layerId,
                name:this.options.layerName,
                map:this.map
            };
            var _lyrOpts=jQuery.extend(lyrOpts,clusterStyle);
            this.layer= new g2.carto.ClusterLayer(_lyrOpts);
            if(!isNaN(_lyrOpts.clusterLevel)){
                this.layer.setClusterLevel(_lyrOpts.clusterLevel);
            }
        },
        /**
         * 添加监听
         * @private
         */
        _addListeners:function(){
            //do parent first
            PointLayer.prototype._addListeners.call(this);
        },
        /**
         * 移除监听
         * @private
         */
        _removeListeners:function(){
            //do parent last
            PointLayer.prototype._removeListeners.call(this);
        },
        _zoomChangeListener:function(event){
            this.updateSymbol(this.map.getZoomLevel());
        },
        /**
         * 批量添加点
         * @method
         * @memberOf G.lys.PointClusterLayer.prototype
         * @param {Array} dataArr - 必填，数据数组
         * @param {Object} options - 可选
         * @param {Number} options.dataSpatialReference - 可选，数据的坐标系，默认为图层的坐标系
         */
        addElements:function(dataArr,options){
            if(!CommonUtil.isArray(dataArr)){
                LoggerUtil.error('dataArr is not an array');
                return ;
            }
            options=options||{};
            //
            var zoom=this.map.getZoomLevel();
            //坐标不正确的数据
            var spatialReference=this.options.spatialReference,
                dataSpatialReference=options.dataSpatialReference||
                    this.options.dataSpatialReference;
            //
            for(var i=0,len=dataArr.length;i<len;i++){
                var data=dataArr[i];
                var point=this._getGeometry(data,dataSpatialReference,spatialReference);
                if(!point){
                    this.noneSpatialArr.push(data);
                    continue;
                }
                var symbolObj=this._getSymbol(data,zoom),
                    elementId=this._getRecordId(data);
                var ele = new g2.sfs.Element({
                    id:elementId,
                    geometry: point,
                    symbol: symbolObj.symbol
                });
                //保存数据
                ele._data=data;
                //当前符号的比例尺级别范围；
                ele._zoomRange=symbolObj.zoomRange;
                //保存当前符号的symbolkey
                ele._symbolKey=symbolObj.symbolKey;
                //保存添加的元素
                this.elements.push(ele);
            }
            this.layer.addElements(this.elements);
            //notify symbol updated
            this._onSymbolsUpdated();
            //notify elements changed
            this._onElementChanged();
        },
        /**
         * 移除要素
         * @method
         * @memberOf G.lys.PointClusterLayer.prototype
         * @param {Array} elementArr - 必填，元素数组
         */
        removeElements:function(elementArr){
            if(CommonUtil.isArray(elementArr)){
                for(var i=elementArr.length-1;i>=0;i--){
                    var ele=elementArr[i];
                    this.layer.remove(ele);
                }
                //notify symbol updated
                this._onSymbolsUpdated();
                //notify elements changed
                this._onElementChanged();
            }
        },
        /**
         * 符号改变时调用的方法
         * @private
         */
        _onSymbolsUpdated:function(){
            var elements=this.layer.elements;
            var k=0,len=elements.length,
                arr=[];
            for(;k<len;k++){
                var ele=elements[k],
                    symbolKey=ele._symbolKey;
                if(symbolKey){
                    var existsObj=this._getSymbolObj(symbolKey,arr);
                    if(existsObj){
                        continue;
                    }
                    var symbolObj=this._getSymbolObj(symbolKey,this.allSymbols);
                    arr.push(symbolObj);
                }
            }
            //
            if(arr.length>0){
                arr.push({
                    symbolKey:'pixel-cluster',
                    symbol:this._clusterSymbol,
                    title:this.options.layerName+'像素聚合'
                });
            }
            //clear current
            this.currentSymbols=null;
            this.currentSymbols=arr;
            //invoke callback
            this.invokeCallback('symbolUpdateCallback',{
                layerId:this.options.layerId,
                symbols:arr
            });
        },
        /**
         * 清空图层
         * @method
         * @memberOf G.lys.PointClusterLayer.prototype
         */
        clear:function(){
            PointLayer.prototype.clear.call(this);
        },
        /**
         * 销毁方法
         * @method
         * @memberOf G.lys.PointClusterLayer.prototype
         */
        destroy:function(){
            PointLayer.prototype.destroy.call(this);
        }
    });
    /**
     * 定义图层类型
     */
    Object.defineProperty(layer,'type',{
        value:13,
        configurable:false,
        writable:false
    });
    return layer;
});
